[
  {
    "voice_id": "11labs-Dorothy",
    "voice_type": "standard",
    "voice_name": "Dorothy",
    "provider": "elevenlabs",
    "accent": "British",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Dorothy.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Dorothy.mp3"
  },
  {
    "voice_id": "11labs-Anthony",
    "voice_type": "standard",
    "voice_name": "Anthony",
    "provider": "elevenlabs",
    "accent": "British",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/anthony.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/anthony.mp3"
  },
  {
    "voice_id": "11labs-Billy",
    "voice_type": "standard",
    "voice_name": "Billy",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/billy.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/billy.mp3"
  },
  {
    "voice_id": "11labs-Lily",
    "voice_type": "standard",
    "voice_name": "Lily",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/lily.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/lily.mp3"
  },
  {
    "voice_id": "11labs-Marissa",
    "voice_type": "standard",
    "voice_name": "Marissa",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Marissa.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/marissa.mp3"
  },
  {
    "voice_id": "11labs-Amy",
    "voice_type": "standard",
    "voice_name": "Amy",
    "provider": "elevenlabs",
    "accent": "British",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/valeria.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Amy.mp3"
  },
  {
    "voice_id": "11labs-Bing",
    "voice_type": "standard",
    "voice_name": "Bing",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/bing.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/bing.mp3"
  },
  {
    "voice_id": "11labs-Jenny",
    "voice_type": "standard",
    "voice_name": "Jenny",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Jenny.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Jenny.mp3"
  },
  {
    "voice_id": "11labs-Lucas",
    "voice_type": "standard",
    "voice_name": "Lucas",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/lucas.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/lucas.mp3"
  },
  {
    "voice_id": "11labs-Samad",
    "voice_type": "standard",
    "voice_name": "Samad",
    "provider": "elevenlabs",
    "accent": "Indian",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/samad.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/samad.mp3"
  },
  {
    "voice_id": "11labs-Brian",
    "voice_type": "standard",
    "voice_name": "Brian",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/brian.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/brian.mp3"
  },
  {
    "voice_id": "11labs-Kate",
    "voice_type": "standard",
    "voice_name": "Kate",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Kate.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/kate.mp3"
  },
  {
    "voice_id": "11labs-Jason",
    "voice_type": "standard",
    "voice_name": "Jason",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Jason.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/jason.mp3"
  },
  {
    "voice_id": "11labs-Ethan",
    "voice_type": "standard",
    "voice_name": "Ethan",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/ethan.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/ethan.mp3"
  },
  {
    "voice_id": "11labs-Paul",
    "voice_type": "standard",
    "voice_name": "Paul",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Old",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/paul.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/paul.mp3"
  },
  {
    "voice_id": "11labs-John",
    "voice_type": "standard",
    "voice_name": "John",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/John.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/John.mp3"
  },
  {
    "voice_id": "11labs-Joe",
    "voice_type": "standard",
    "voice_name": "Joe",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/joe.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/joe.mp3"
  },
  {
    "voice_id": "11labs-Adrian",
    "voice_type": "standard",
    "voice_name": "Adrian",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/adrian.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/adrian.mp3"
  },
  {
    "voice_id": "11labs-Gilfoy",
    "voice_type": "standard",
    "voice_name": "Gilfoy",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/gilfoy.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/gilfoy.mp3"
  },
  {
    "voice_id": "11labs-Zuri",
    "voice_type": "standard",
    "voice_name": "Zuri",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Old",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Zuri.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/zuri.mp3"
  },
  {
    "voice_id": "11labs-Noah",
    "voice_type": "standard",
    "voice_name": "Noah",
    "provider": "elevenlabs",
    "accent": "Australian",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/noah.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/noah.mp3"
  },
  {
    "voice_id": "11labs-Steve",
    "voice_type": "standard",
    "voice_name": "Steve",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Old",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Steve.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Steve-.mp3"
  },
  {
    "voice_id": "11labs-Grace",
    "voice_type": "standard",
    "voice_name": "Grace",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/grace.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/grace.mp3"
  },
  {
    "voice_id": "11labs-Chloe",
    "voice_type": "standard",
    "voice_name": "Chloe",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Chloe.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/chloe.mp3"
  },
  {
    "voice_id": "11labs-Max",
    "voice_type": "standard",
    "voice_name": "Max",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/max.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Max.mp3"
  },
  {
    "voice_id": "11labs-Anna",
    "voice_type": "standard",
    "voice_name": "Anna",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/anna.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/anna.mp3"
  },
  {
    "voice_id": "11labs-Julia",
    "voice_type": "standard",
    "voice_name": "Julia",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Julia.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/julia.mp3"
  },
  {
    "voice_id": "11labs-victoria",
    "voice_type": "standard",
    "voice_name": "Victoria",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Victoria.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Victoria.mp3"
  },
  {
    "voice_id": "11labs-Susan",
    "voice_type": "standard",
    "voice_name": "Susan",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Susan.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/susan.mp3"
  },
  {
    "voice_id": "11labs-charlie",
    "voice_type": "standard",
    "voice_name": "Charlie",
    "provider": "elevenlabs",
    "accent": "Australian",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/charlie.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Charlie.mp3"
  },
  {
    "voice_id": "11labs-Emily",
    "voice_type": "standard",
    "voice_name": "Emily",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/emily.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/emily.mp3"
  },
  {
    "voice_id": "11labs-Kathrine",
    "voice_type": "standard",
    "voice_name": "Kathrine",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/kathrine.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Kathrine.mp3"
  },
  {
    "voice_id": "11labs-Monika",
    "voice_type": "standard",
    "voice_name": "Monika",
    "provider": "elevenlabs",
    "accent": "Indian",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/monika.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/monika.mp3"
  },
  {
    "voice_id": "11labs-Andrew",
    "voice_type": "standard",
    "voice_name": "Andrew",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/andrew.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/andrew.mp3"
  },
  {
    "voice_id": "11labs-Nina",
    "voice_type": "standard",
    "voice_name": "Nina",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.mp3"
  },
  {
    "voice_id": "11labs-Amritanshu",
    "voice_type": "standard",
    "voice_name": "Amritanshu",
    "provider": "elevenlabs",
    "accent": "Indian",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Amritanshu.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Amritanshu.mp3"
  },
  {
    "voice_id": "11labs-Santiago",
    "voice_type": "standard",
    "voice_name": "Santiago",
    "provider": "elevenlabs",
    "accent": "Spanish",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Santiago.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Santiago.mp3"
  },
  {
    "voice_id": "11labs-Myra",
    "voice_type": "standard",
    "voice_name": "Myra",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Myra.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/myra.mp3"
  },
  {
    "voice_id": "11labs-Paola",
    "voice_type": "standard",
    "voice_name": "Paola",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Paola.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/paola.mp3"
  },
  {
    "voice_id": "11labs-Evie",
    "voice_type": "standard",
    "voice_name": "Evie",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/evie.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/evie.mp3"
  },
  {
    "voice_id": "11labs-Carola",
    "voice_type": "standard",
    "voice_name": "Carola",
    "provider": "elevenlabs",
    "accent": "German",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/carola.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Carola.mp3"
  },
  {
    "voice_id": "11labs-James",
    "voice_type": "standard",
    "voice_name": "James",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Old",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/james.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/James.mp3"
  },
  {
    "voice_id": "11labs-Cimo",
    "voice_type": "standard",
    "voice_name": "Cimo",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/cimo.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/cimo.mp3"
  },
  {
    "voice_id": "11labs-Ryan",
    "voice_type": "standard",
    "voice_name": "Ryan",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Young",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/ryan.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/ryan.mp3"
  },
  {
    "voice_id": "11labs-Mia",
    "voice_type": "standard",
    "voice_name": "Mia",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/mia.png",
    "preview_audio_url": "https://retell-utils-public.s3.us-west-2.amazonaws.com/Mia.mp3"
  },
  {
    "voice_id": "custom-Young-Jamal",
    "voice_type": "custom",
    "voice_name": "Jaden",
    "provider": "elevenlabs",
    "gender": "male",
    "accent": "American",
    "age": "Middle Aged",
    "avatar_url": "https://randomuser.me/api/portraits/men/54.jpg",
    "preview_audio_url": "https://pub-2b267f9560eb4906bfb3c3a173348446.r2.dev/custom-jaden.mp3"
  },
  {
    "voice_id": "custom-Carolina",
    "voice_type": "custom",
    "voice_name": "Maria",
    "provider": "elevenlabs",
    "accent": "Spanish",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://randomuser.me/api/portraits/women/40.jpg",
    "preview_audio_url": "https://pub-2b267f9560eb4906bfb3c3a173348446.r2.dev/custom-Carolina.mp3"
  },
  {
    "voice_id": "custom_voice_a064cb9028786e2d7f42e78119",
    "voice_type": "custom",
    "voice_name": "Scarlett",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "female",
    "age": "Middle Aged",
    "avatar_url": "https://randomuser.me/api/portraits/women/0.jpg",
    "preview_audio_url": "https://pub-2b267f9560eb4906bfb3c3a173348446.r2.dev/custom-Scarlett.mp3"
  },
  {
    "voice_id": "custom_voice_8186df44065a785674e51aa4fb",
    "voice_type": "custom",
    "voice_name": "Hunter",
    "provider": "elevenlabs",
    "accent": "American",
    "gender": "male",
    "age": "Middle Aged",
    "avatar_url": "https://randomuser.me/api/portraits/men/72.jpg",
    "preview_audio_url": "https://pub-2b267f9560eb4906bfb3c3a173348446.r2.dev/custom-Hunter.mp3"
  },
  {
    "voice_id": "custom-Robert-Calm",
    "voice_type": "custom",
    "voice_name": "Robert - Calm and Confident",
    "provider": "elevenlabs",
    "gender": "male",
    "avatar_url": "",
    "preview_audio_url": "https://pub-2b267f9560eb4906bfb3c3a173348446.r2.dev/custom-Robert-Calm.mp3"
  },
  {
    "voice_id": "custom_voice_3be14aaff935bf713f38329257",
    "voice_type": "custom",
    "voice_name": "Hawaiian Female",
    "provider": "elevenlabs",
    "avatar_url": "",
    "preview_audio_url": "https://pub-2b267f9560eb4906bfb3c3a173348446.r2.dev/custom-hawaiian-female.mp3"
  }
]
